exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-eae51f1c]{position:relative}.active-label[data-v-eae51f1c]{position:absolute;top:0;left:20px;font-size:14px;color:rgba(0,0,0,.6);z-index:99}.title-class[data-v-eae51f1c]{font-size:1.35rem;color:rgba(0,0,0,.6)}.btnToggle[data-v-eae51f1c]{width:100%}.spacing-field-align[data-v-eae51f1c]{@media screen and (min-width:960px){padding-top:9px;padding-bottom:9px}}.label-description[data-v-eae51f1c]{font-size:12px;color:rgba(0,0,0,.8)}.warn-card-title[data-v-eae51f1c]{background-color:#fb8c00;color:#fff;font-weight:700}.cnpj-text-field[data-v-eae51f1c] .v-input__append-inner{margin-top:6px!important}", ""]);

// exports
